<template>
  <el-container class="layout-container">
    <el-header class="header" :class="{ 'is-mobile': isMobile }">
      <div class="logo">
        <router-link to="/">
          <img src="./assets/logo.svg" alt="广泰微科技">
        </router-link>
      </div>
      <el-menu
        v-if="!isMobile"
        mode="horizontal"
        :router="true"
        class="nav-menu"
      >
        <el-menu-item index="/">首页</el-menu-item>
        <el-menu-item index="/products">产品中心</el-menu-item>
        <el-menu-item index="/solutions">解决方案</el-menu-item>
        <el-menu-item index="/about">关于我们</el-menu-item>
        <el-menu-item index="/news">新闻动态</el-menu-item>
      </el-menu>
      <el-button v-else class="mobile-menu-btn" @click="showMobileMenu = true">
        <el-icon><Menu /></el-icon>
      </el-button>
    </el-header>

    <el-drawer
      v-model="showMobileMenu"
      direction="rtl"
      size="70%"
      class="mobile-menu"
    >
      <el-menu
        mode="vertical"
        :router="true"
        @select="showMobileMenu = false"
      >
        <el-menu-item index="/">首页</el-menu-item>
        <el-menu-item index="/products">产品中心</el-menu-item>
        <el-menu-item index="/solutions">解决方案</el-menu-item>
        <el-menu-item index="/about">关于我们</el-menu-item>
        <el-menu-item index="/news">新闻动态</el-menu-item>
      </el-menu>
    </el-drawer>

    <el-main>
      <router-view />
    </el-main>

    <el-footer class="footer">
      <div class="contact-info">
        <p>电话：+86-18682063930</p>
        <p>邮箱：321justice@163.com</p>
        <p>地址：深圳市宝安区沙井新桥街道上星路星悦豪庭1期2栋</p>
      </div>
      <div class="copyright">
        © 2024 深圳市广泰微科技有限公司 版权所有 <a href="https://beian.miit.gov.cn/" target="_blank" class="beian">粤ICP备2024240286号</a>
      </div>
    </el-footer>
  </el-container>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'
import { Menu} from '@element-plus/icons-vue'

export default {
  name: 'App',
  components: {
    Menu,
    // WeChat,
    // Message
  },
  setup() {
    const isMobile = ref(false)
    const showMobileMenu = ref(false)

    const checkMobile = () => {
      isMobile.value = window.innerWidth <= 768
    }

    onMounted(() => {
      checkMobile()
      window.addEventListener('resize', checkMobile)
    })

    onUnmounted(() => {
      window.removeEventListener('resize', checkMobile)
    })

    return {
      isMobile,
      showMobileMenu
    }
  }
}
</script>

<style lang="scss">
.layout-container {
  min-height: 100vh;
}

.header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 100;
  background: white;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;

  &.is-mobile {
    padding: 0 15px;
  }

  .logo {
    height: 50px;
    img {
      height: 100%;
      object-fit: contain;
    }
  }

  .nav-menu {
    border: none;
  }

  .mobile-menu-btn {
    padding: 8px;
  }
}

.el-main {
  margin-top: 60px;
  min-height: calc(100vh - 60px - 300px);
  padding: 20px;
}

.footer {
  // background-color: #2c3e50;
  color: #2c3e50;
  padding: 40px 20px 20px;
  text-align: center;

  .contact-info {
    margin-bottom: 30px;

    p {
      margin: 10px 0;
      font-size: 14px;
      // color: rgba(255, 255, 255, 0.9);
      line-height: 1.6;
    }
  }

  .copyright {
    padding: 20px;
    border-top: 1px solid rgba(0,0,0, 0.1);
    // color: rgba(255, 255, 255, 0.8);
    font-size: 14px;

    .beian {
      color: #2c3e50;
      text-decoration: none;
      margin-left: 10px;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}

@media (max-width: 768px) {
  .footer {
    .footer-content {
      grid-template-columns: 1fr;
    }
  }
}
</style>
